import { User } from "../models/user.model";
import { GraphQLService } from "./graphql.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable()
export class LoginService extends GraphQLService<User> {
  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  checkEmail(user: User): Observable<User> {
    return this.push(`checkEmail(username: "${ user.username }") { requireLogin }`)
  }

  doLogin(user: User, locale: string): Observable<User> {
    return this.push(`mutation { doLogin(username: "${ user.username }", password: "${ user.password }", iso: "${ locale }") { email username name persistenceToken prepayment paymentTerms { days } } }`)
  }

  doLogout(persistenceToken: string): Observable<User> {
    return this.push(`mutation { doLogout(persistenceToken: "${ persistenceToken }") }`)
  }

  checkLogin(persistenceToken: string): Observable<User> {
    return this.push(`mutation { checkLogin(persistenceToken: "${ persistenceToken }") { email username name persistenceToken prepayment paymentTerms { days } } }`)
  }

}
